import React from 'react';

import { noopCallback } from '@looko-corp/acloset-react-kit';
import { acCaptureException } from '@looko-corp/acloset-react-kit/src/sentry';

import { useUserAuth } from '@/state/cookieContext';

import { analyticsService } from '.';

/**
 * Analytics 활성화.
 */
export const useEnableAnalyticsEffect = () => {
  const userAuth = useUserAuth();

  const userID = userAuth?.userID;

  React.useEffect(() => {
    try {
      // NOTE: amplitude 비활성화
      return;

      analyticsService.enable();

      if (analyticsService.isLoaded()) {
        analyticsService.setUser(userID?.toString());
        return;
      }

      void analyticsService.load(userID?.toString()).catch(noopCallback);
    } catch (err) {
      acCaptureException('Failed to load Analytics.', err);
    }
  }, [userID]);
};
